// extracted by mini-css-extract-plugin
var _1 = "TI60ZTg2AeeY2miLzopZ";
var _2 = "ZgNPzP8NR8ZxzaswD9Cd";
var _3 = "SPtBppgnzyuUFifXOpFc";
var _4 = "iALb2HL5bBzL8anOK0tq";
var _5 = "CnUz79wJ7ufEi_h3N0ux";
export { _1 as "closeIcon", _2 as "info", _3 as "negative", _4 as "normal", _5 as "root" }
